export const TargetGroupType = Object.freeze({
    CREATE: "Create",
    VIEW: "View",
    DISTRIBUTOR: "Distributor"
})